import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { T } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import { Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { toggleShowConflictsAlert } from '../../Reducers/Configurator/Actions';

const useStyles = makeStyles(
  (theme) => {
    return {
      incompatibilityDialog: {
        '& .MuiDialog-container': {
          '& .MuiDialog-paperWidthMd': {
            maxWidth: 700,
          },
        },
      },
      incompatibilityFooter: {
        padding: '10px 32px 32px 24px',
        textAlign: 'right',

        '& button': {
          marginLeft: 10,
          background: theme.palette.primary.darkText,
          color: 'white',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#616161',
          },
        },
        [theme.breakpoints.down('xs')]: {
          '& button': {
            marginLeft: 0,
            marginBottom: 10,
          },
        },
      },
    };
  },
  {
    name: 'IncompatibilityAlert',
  }
);

const IncompatibilityAlert = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const showConflictsAlert = useSelector((state) =>
    get(state, 'configurator.configuration.customdata.showConflictsAlert', false)
  );
  return (
    <CustomDialog
      open={showConflictsAlert}
      dialogTitle={T('incompatibility.dialogTitle')}
      onClose={() => dispatch(toggleShowConflictsAlert(false))}
      onCancel={() => dispatch(toggleShowConflictsAlert(false))}
      className={classes.incompatibilityDialog}
    >
      <>
        <DialogContent className={'incompatibility'}>
          <Typography variant="body2">{T('incompatibilityAlert')}</Typography>
        </DialogContent>
        <div className={classes.incompatibilityFooter}>
          <Button onClick={() => dispatch(toggleShowConflictsAlert(false))} variant="contained">
            {T('incompatibility.okButton')}
          </Button>
        </div>
      </>
    </CustomDialog>
  );
};
export default IncompatibilityAlert;
